// 日期格式化工具

/**
 * 将 "2026-02-04 12:00:00" 格式化为 "2026-02-04"
 * @param {string} dateStr - 日期字符串
 * @returns {string}
 */
export function formatDateToDay(dateStr) {
  if (!dateStr) return ''
  return String(dateStr).split(' ')[0]
}

/**
 * 从日期字符串中提取年份
 * @param {string} dateStr - 日期字符串
 * @returns {string}
 */
export function getYearFromDate(dateStr) {
  return formatDateToDay(dateStr).split('-')[0] || ''
}

/**
 * 格式化对象中的 create_time 字段
 * @param {Object} item - 包含 create_time 的数据对象
 * @returns {Object}
 */
export function formatCreateTime(item) {
  if (item && item.create_time) {
    item.create_time = formatDateToDay(item.create_time)
  }
  return item
}



// WEBPACK FOOTER //
// ./src/utils/dateFormat.js